export default class PaymentMethod {

    constructor($view) {

        this.$view = $view;

        this.$homeCbMethod = this.$view.find('.js-home-cb-method');
        this.$homeRibMethod = this.$view.find('.js-home-rib-method');
        this.$relayCbMethod = this.$view.find('.js-relay-cb-method');
        this.$relayRibMethod = this.$view.find('.js-relay-rib-method');

        this.$cbInput = this.$view.find('.js-cb-input');
        this.$ribInput = this.$view.find('.js-rib-input');
        this.bind();
    }

    bind() {
        this.$cbInput.on('change', () => this.renderDays());
        this.$ribInput.on('change', () => this.renderDays());
    }

    renderDays() {
        if (this.$ribInput[0].checked) {
            this.$homeRibMethod.removeClass('d-none');
            this.$relayRibMethod.removeClass('d-none');
            this.$homeCbMethod.addClass('d-none');
            this.$relayCbMethod.addClass('d-none');
        } else {
            this.$homeRibMethod.addClass('d-none');
            this.$relayRibMethod.addClass('d-none');
            this.$homeCbMethod.removeClass('d-none');
            this.$relayCbMethod.removeClass('d-none');
        }
    }

}
